///
/// EarthBrowser
///
/// Migration v29 to v30: Unify dataset visibility
/// Created by Matt Giger on September 6, 2026
/// Copyright (c) 2026 Geodata Labs
///

interface EarthbrowserStateV29 {
	cloudsVisible?: boolean
	radarVisible?: boolean
	visibleDatasets?: string[]
}

interface StateV29 {
	earthbrowser?: EarthbrowserStateV29
}

/**
 * Migration: v29 to v30
 *
 * Changes:
 * - Folds earthbrowser.cloudsVisible into visibleDatasets as "cloud"
 * - Folds earthbrowser.radarVisible into visibleDatasets as "precipitation"
 * - Removes the cloudsVisible and radarVisible fields
 *
 * The old boolean flags were the source of truth for the engine layers, so
 * they win over any stale "cloud" entry in visibleDatasets.
 */
export function migrateV29toV30(state: unknown): unknown {
	const s = state as StateV29 | null | undefined
	if (!s?.earthbrowser) return state

	const { cloudsVisible, radarVisible, ...earthbrowser } = s.earthbrowser

	let visible: string[] = Array.isArray(earthbrowser.visibleDatasets)
		? [...earthbrowser.visibleDatasets]
		: []

	// cloudsVisible defaulted to true
	const cloudsOn = cloudsVisible !== false
	if (cloudsOn && !visible.includes("cloud")) {
		visible.push("cloud")
	} else if (!cloudsOn) {
		visible = visible.filter(type => type !== "cloud")
	}

	// radarVisible defaulted to false
	if (radarVisible === true && !visible.includes("precipitation")) {
		visible.push("precipitation")
	}

	return {
		...s,
		earthbrowser: {
			...earthbrowser,
			visibleDatasets: visible,
		},
	}
}
